module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/editnode-df3982dd4acfebcd3d1eb3d2da9b2241.svg";